import { getCookie } from '../commons/utils';
import { purgeState } from './../actions/commonActions';

function log403(args) {
	// const { message, endpoint, payload = {}, ...props } = args;
	// const e = new Error(message);
	// /*Raven.captureException(e, {
	//     extra: {
	//         uri: endpoint,
	//         payload: JSON.stringify(payload),
	//         CSRFToken: getCookie('csrftoken'),
	//         ...props,
	//     },
	// });*/
}

function handle400AndAbove(request, reject, { endpoint, payload }, store) {
	const { status, responseText } = request;
	switch (status) {
		case 400:
			store.dispatch({
				type: 'UPDATE_ERROR',
				payload: {
					flag: true,
					reason: 'Incorrect username or password',
				},
			});
			break;
		case 401:
			store.dispatch(purgeState());
			console.log('check');
			reject({});
			break;

		case 403:
			log403({
				message: '403 Forbidden',
				endpoint,
				payload,
			});
			reject({});
			break;

		default:
			// any other 4xx error should send back a json response with errors
			try {
				const json = JSON.parse(responseText);
				reject({
					json: json,
					status,
				});
			} catch (e) {
				reject({
					json: {},
					status,
				});
			}
			break;
	}
}

function handle200To400(request, resolve) {
	let jsonResponse = request.status === 204 ? {} : JSON.parse(request.responseText);
	resolve({
		isServerOK: true,
		...jsonResponse,
	});
}

export function postApi({ endpoint, payload, method = 'POST', payloadAsIs, currState }, store) {
	store.dispatch({ type: 'START_SPINNER' });
	return new Promise(function (resolve, reject) {
		let request = new XMLHttpRequest();
		let modifiedPayload = payload;
		if (!payloadAsIs) {
			modifiedPayload = payload;
		}
		const params = modifiedPayload;
		request.open(method, endpoint, true);
		request.setRequestHeader('X-CSRFToken', getCookie('csrftoken'));
		request.setRequestHeader('x-dentalcorp-api-key', 'fb4a6b72-a08a-4331-8d95-c7046ec6cd22');
		request.setRequestHeader('x-dentalcorp-sessiontoken', currState.session.sessiontoken);
		request.setRequestHeader('Content-type', 'application/json');
		request.onload = () => {
			if (request.status >= 200 && request.status < 400) {
				store.dispatch({ type: 'STOP_SPINNER' });
				handle200To400(request, resolve);
			} else {
				store.dispatch({ type: 'STOP_SPINNER' });
				handle400AndAbove(request, reject, { endpoint, payload }, store);
			}
		};
		request.send(JSON.stringify(params));
	});
}

export const POST_API = Symbol('Post API');

export default (store) => (next) => (action) => {
	const postAPI = action[POST_API];
	if (typeof postAPI === 'undefined') {
		return next(action);
	}

	let { endpoint, payload, method = 'post' } = postAPI;

	if (typeof endpoint === 'function') {
		endpoint = endpoint(store.getState());
	}
	if (typeof endpoint !== 'string') {
		throw new Error('Specify a string endpoint URL.');
	}

	if (typeof payload === 'function') {
		payload = payload(store.getState());
	}

	if (typeof payload !== 'object') {
		throw new Error('Specify the payload for POST request');
	}

	function handlePostApi(currState) {
		const { payloadAsIs = false } = postAPI;

		return postApi({ endpoint, payload, method, payloadAsIs, currState }, store).then(
			(response) => {
				const { onSuccess } = postAPI;
				if (onSuccess) {
					if (typeof onSuccess !== 'function') {
						throw new Error('Success Callback should be a function');
					}
					onSuccess(response, store.getState(), store.dispatch);
				}
			},
			({ status, json: response }) => {
				// stop going any further if rejection promise didn't send in status
				// this would happen only for 401s and 403s.
				if (typeof status === 'undefined') {
					return;
				}

				try {
					let failureTypeActionData = {
						errors: postAPI.failureActionErrors ? postAPI.failureActionErrors(response, store.getState(), store.dispatch) : response.error ? response.error : null,
					};

					if (!failureTypeActionData.errors) {
						console.error('failureActionErrors should be a function');
						throw new Error('failureActionErrors should be a function');
					}

					if (postAPI.failureTypeActionProps) {
						failureTypeActionData = {
							...failureTypeActionData,
							...postAPI.failureTypeActionProps,
						};
					}

					//next(actionWith({ type: SCROLL_TO_FIRST_ERROR }));

					const { onFailure } = postAPI;
					if (onFailure) {
						if (typeof onFailure !== 'function') {
							throw new Error('Failure Callback should be a function');
						}
						onFailure(response, store.getState(), store.dispatch);
					}
				} catch (e) {
					console.error(e.stack);
					/*Raven.captureException(e, {
                        extra: {
                            endpoint,
                            status,
                            payload: JSON.stringify(payload),
                            response: JSON.stringify(response),
                            state: JSON.stringify(store.getState()),
                        },
                    });*/
				}
			}
		);
	}

	let { validator } = postAPI;
	let { toValidate } = postAPI;
	if (typeof validator === 'function' && typeof toValidate !== 'function') {
		throw new Error('Expected toValidate to be a function since you supplied a validator method');
	}

	if (!validator) {
		return handlePostApi(store.getState());
	}

	if (typeof toValidate === 'function') {
		toValidate = toValidate(store.getState());
	}

	// if LGTM validator is not passed, it's a function that returns the LGTM instance
	if (!('validate' in validator)) {
		validator = validator(store.getState());
		if (!('validate' in validator)) {
			throw new Error('Expected Validator to be instance of LGTM');
		}
	}

	validator.validate(toValidate, (e, result) => {
		if (result.valid) {
			return handlePostApi();
		}
	});
};
